<template>
  <fragment v-if="renderType === type.UploadDataTable">
    <div class="form-group row align-items-center">
      <label class="col-sm-2 mb-sm-4">Upload Document</label>
      <app-input class="col-sm-8 mb-sm-4 mr-sm-2"
                 type="file"
                 v-model="fileObj.files"
                 placeholder="Upload Document"/>
      <label class="col-sm-2 mb-sm-0">Select Type</label>
      <app-input class="col-sm-8 mb-sm-0"
                 type="select"
                 :list="list"
                 v-model="fileObj.type"
                 placeholder=""/>
    </div>
    <div class="form-group row align-items-center">
      <label class="col-sm-2 mb-sm-0">File Name</label>
      <app-input class="col-sm-8 mb-sm-0"
                 type="text"
                 v-model="fileObj.file_name"
                 placeholder="Input file name"/>

    </div>
    <div class="form-row mt-5 d-flex align-items-center">
      <el-button class="btn btn-primary el-button--default"
                 @click="uploadBtnHandler">
        Upload File
      </el-button>
    </div>
  </fragment>
  <fragment v-else-if="type.CandidateDetail">
    <div class="form-group col-sm-4">
      <label>Upload File</label>
      <el-button class="btn btn-primary el-button--default col-sm-12 uploadBtnCustomStyle"
                 @click.prevent="$refs.file.click()">
        Choose&nbsp;File
      </el-button>
      <input type="file"
             ref="file"
             style="display:none"
             v-on:change="fileChange"/>
    </div>
  </fragment>
  <fragment v-else>
    <div class="form-group col-sm-4">
      <label>Upload Result (PDF)</label>
      <el-button class="btn btn-primary el-button--default col-sm-12"
                 @click.prevent="$refs.file.click()"
                 style="background-color:#4466f2; color: #ffffff">
        Choose&nbsp;File
      </el-button>
      <input type="file"
             ref="file"
             style="display:none"
             accept="application/pdf"
             v-on:change="fileChange"/>
    </div>
  </fragment>
</template>

<script>
import {documentTypeList} from '@Views/Screening/utility/constant';
import {File} from "@Views/Screening/utility/apiAgent";
import {uploadBtnRenderType} from '@Views/Screening/utility/enums';

export default {
  name: "UploadBtn",
  props: {
    fileObj: {
      type: Object,
    },
    emailAddress: {
      type: String,
    },
    tableId: {
      type: String
    },
    renderType: {
      type: String
    },
    searchDocument: {
      type: Object
    },
    filesForDocumentTable: {
      type: Array
    },
    error: {
      type: Object
    }
  },
  data() {
    return {
      list: documentTypeList,
      searchUploadedFile: null,
      type: uploadBtnRenderType
    }
  },
  methods: {
    uploadBtnHandler() {
      let data;
      if (this.renderType === this.type.UploadDataTable) {
        data = {
          ...this.fileObj,
          email: this.emailAddress
        };
      } else if (this.renderType === this.type.CandidateDetail) {
        data = {
          files: this.searchUploadedFile,
          type: 'CandidateDetailDocument',
          email: this.emailAddress
        };
      } else {
        data = {
          files: this.searchUploadedFile,
          type: this.fileObj.search_type,
          email: this.emailAddress
        };
      }
      // changes-ends here.
      // const data = (this.renderType === this.type.UploadDataTable) ?
      //     {...this.fileObj, email: this.emailAddress}
      //     :
      //     {files: this.searchUploadedFile, type: 'ConfirmationLetter', email: this.emailAddress};
      let formData = new FormData;
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }
      File.uploadDocument(formData)
          .then(({data}) => {
            if (this.renderType === this.type.Search) {
              const _documentId = data.data[0].id;
              this.$set(this.fileObj.files, this.fileObj.files.length, _documentId);
              this.$set(this.searchDocument, 'file', {
                id: _documentId,
                name: data.data[0].file_name,
                fileURL: window.URL.createObjectURL(this.searchUploadedFile),
                ...data.data[0]
              });
              this.searchUploadedFile = null;
            }
            else {
              this.fileObj.documentId = data.data[0].id;
            }
            this.$toastr.s(data.message);
          })
          .catch(({error}) => {
            //trigger after error
          })
          .finally(() => {
            if (this.tableId) {
              this.fileObj.file_name = '';
              this.$hub.$emit("reload-" + this.tableId);
            }
          });
    },
    fileChange(event) {
      this.isError = false;
      const files = event.target.files || event.dataTransfer.files;
      const isExist = this.filesForDocumentTable && this.filesForDocumentTable.find(x => x.name === files[0].name);
      if (isExist) {
        this.$set(this.error, 'errorMessage', 'File with this name already inserted.');
        this.$set(this.error, 'isError', true);
        return;
      }
      this.searchUploadedFile = files[0];
      try {
        this.uploadBtnHandler();
        this.$toastr.s('File uploaded successfully.');
      } catch (e) {
        this.$toastr.e('Something went wrong.');

      }
    }
  }
}
</script>

<style scoped>
.uploadBtnCustomStyle {
  background-color: #4466f2;
  color: #ffffff;
}
</style>